import React, { useState, useEffect } from 'react';
import View from 'src/components/view';
import Element from 'src/components/element';
import utils from 'src/components/utils';
import { format } from 'date-fns';

function RelatorioPontuacaoRedeAmericaLatina() {
  let [view, setView] = useState({});
  let [crud, setCrud] = useState({ data: {}, changed: {}, requireds: {}, selected: {} });

  // let agora = new Date();
  // let mesReferencia = format( agora, "MM" );
  // let anoReferencia = format( agora, "yyyy" );

  // let clienteLogado = utils.getCliente();

  const reportCfg = {
    label: utils.lng('pontuacao_em_rede', 'Pontuação em Rede'),
    name: 'reportCfg',
    add: false,
    print: true,
    type: 'list',
    table: true,
    auto: true,
    list: {
      url: 'report_pontuacaoRedeAmericaLatina',
      validate: 'validaPeriodo',
    },
    filters: {
      mes_referencia: {
        type: 'select',
        label: utils.lng('mes', 'Mês'),
        data: [
          //{ label: utils.lng('selecione', "Selecione"), value: null },
          { label: utils.lng('mes_01', 'Janeiro'), value: '_01' },
          { label: utils.lng('mes_02', 'Fevereiro'), value: '_02' },
          { label: utils.lng('mes_03', 'Março'), value: '_03' },
          { label: utils.lng('mes_04', 'Abril'), value: '_04' },
          { label: utils.lng('mes_05', 'Maio'), value: '_05' },
          { label: utils.lng('mes_06', 'Junho'), value: '_06' },
          { label: utils.lng('mes_07', 'Julho'), value: '_07' },
          { label: utils.lng('mes_08', 'Agosto'), value: '_08' },
          { label: utils.lng('mes_09', 'Setembro'), value: '_09' },
          { label: utils.lng('mes_10', 'Outubro'), value: '_10' },
          { label: utils.lng('mes_11', 'Novembro'), value: '_11' },
          { label: utils.lng('mes_12', 'Dezembro'), value: '_12' },
        ],
        // , change: { action: 'validaPeriodo' }
      },
      ano_referencia: {
        type: 'number',
        label: utils.lng('ano', 'Ano'),
        // ,change: { action: 'validaPeriodo' },
      },
      // date: {
      //   type: 'date',
      //   monthYear: true,
      //   range: false,
      //   dateFormat: 'long',
      //   label: utils.lng('periodo', "Período")
      // },
      id_cliente: {
        type: 'entity',
        entity: 'Cliente',
        label: utils.lng('cliente_distribuidor', 'Cliente'),
        list: {
          url:
            utils.getUser().administrativo === true || (utils.getUser().tipo + '').indexOf('ADMINISTRATIVO') > -1
              ? 'endpoint_listar_all_clientes'
              : 'endpoint_listar_clientes_minha_rede',
        },
        itemLabel: 'nome',
        itemValue: 'id',
      },
      mostrar_di_sem_pontos: {
        type: 'checkbox',
        label: utils.lng('mostrar_dis_sem_pontos', 'Mostrar DIs sem pontos'),
        space: 3,
      },
      id_tipo_movimento: {
        type: 'select',
        label: utils.lng('tipo_movimento', 'Tipo Movimento'),
        list: { url: 'TipoMovimento' },
        itemLabel: 'descricao',
        itemValue: 'id',
        rendered: utils.getUser().administrativo === true || (utils.getUser().tipo + '').indexOf('ADMINISTRATIVO') > -1,
      },
    },
    columns: {
      arvore_geracao: {
        field: 'arvore_geracao',
        label: utils.lng('arvore_geracoes', 'Árvore de Gerações'),
        filter: false,
        sort: false,
      },
      codigo_mundial: {
        field: 'codigo_mundial',
        label: utils.lng('codigo_mundial', 'Código Mundial'),
        filter: false,
        sort: false,
      },
      nome_cliente: {
        field: 'nome_cliente',
        label: utils.lng('distribuidor', 'Distribuidor'),
        filter: false,
        sort: true,
      },
      descricao_graduacao_titulo: {
        field: 'descricao_graduacao_titulo',
        label: utils.lng('graduacao', 'Graduação'),
        filter: false,
        sort: false,
      },
      pontos_individuais: {
        field: 'pontos_individuais',
        format: 'number',
        type: 'number',
        decimalCount: 2,
        label: utils.lng('pontos_individuais', 'Pontos Individuais'),
        filter: false,
        sort: true,
      },
      pontos_rede: {
        field: 'pontos_rede',
        format: 'number',
        type: 'number',
        decimalCount: 2,
        label: utils.lng('pontos_equipe', 'Pontos em Equipe'),
        filter: false,
        sort: true,
      },
      pontuacao_geral: {
        field: 'pontuacao_geral',
        format: 'number',
        type: 'number',
        decimalCount: 2,
        label: utils.lng('pontuacao_geral', 'Pontuação Geral'),
        filter: false,
        sort: true,
      },
      nr_filhos_diretos: {
        field: 'nr_filhos_diretos',
        label: utils.lng('nr_filhos_diretos', 'Nº Filhos Diretos'),
        filter: false,
        sort: false,
      },
      status_penn: { field: 'status_penn', label: utils.lng('status_penn', 'Status Penn'), filter: false, sort: false },
      data_ativacao: {
        field: 'data_ativacao',
        label: utils.lng('data_ativacao', 'Data Ativação'),
        filter: false,
        sort: false,
        type: 'date',
      },
      dh_ultima_compra: {
        field: 'dh_ultima_compra',
        label: utils.lng('dh_ultima_compra', 'Data última compra'),
        filter: false,
        sort: false,
        type: 'date',
      },
      dh_atualizacao_saldo: {
        field: 'dh_atualizacao_saldo',
        label: utils.lng('data_atualizacao', 'Data Atualização'),
        filter: false,
        sort: false,
        type: 'datetime',
      },
    },
  };

  let [mobile, setMobile] = useState(false);

  const resize = function () {
    mobile = window.innerWidth <= 989;
    setMobile(mobile);
    window.mobile = mobile;
  };

  useEffect(() => {
    window.addEventListener('resize', resize.bind(this));
    resize();
  }, []);

  return (
    <View className="ui-view-report" name="rel-pontuacao_rede_america_latina">
      <Element value={reportCfg} crud={crud} data={crud.data} view={view}></Element>
    </View>
  );
}

export default RelatorioPontuacaoRedeAmericaLatina;
